import styled from 'styled-components'
import { Column, Row } from '@shipt/design-system-layouts'
import { Body, Headline } from '@shipt/design-system-typography'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { type PlaceholderData } from '@/features/cms/components/CMS/types'
import { screenSizes } from '@shipt/design-system-themes'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { useEffect } from 'react'
import { useCMSTrackingEvents } from '@/features/cms/components/CMS/CMSContext'
import { theme } from '@/features/shared/constants/shiptTheme'

type Props = PlaceholderData & {
  title: string
  subtitle: string
  imgMobile: string
  imgDesktop: string
  trackingName: string
}

export const ValuePropCard = ({
  id,
  content_type_id,
  title,
  subtitle,
  imgMobile,
  imgDesktop,
  trackingName,
}: Props) => {
  const { trackCMSElementViewed } = useCMSTrackingEvents()

  useEffect(() => {
    trackCMSElementViewed({
      type: 'banner',
      content: trackingName,
    })
  }, [trackCMSElementViewed, trackingName])

  return (
    <GridLayoutContainer {...getCMSWrapperProps({ content_type_id, id })}>
      <Container align="center" justify="space-between">
        <Column padding={{ base: ['lg'], md: ['lg', 0, 'lg', 'lg'] }}>
          <Headline>{title}</Headline>
          <Body size="md">{subtitle}</Body>
        </Column>
        <ImageMobile src={imgMobile} alt="" width={144} height={192} quality={100} />
        <ImageWeb src={imgDesktop} alt="" width={405} height={90} quality={100} />
      </Container>
    </GridLayoutContainer>
  )
}

const Container = styled(Row)`
  border: 1px solid ${theme.color.border.base.neutral.subtle};
  border-radius: 0.5rem;
  overflow: hidden;
`

const ImageWeb = styled(Image)`
  height: 100%;
  object-fit: cover;

  @media ${screenSizes.max_mobile} {
    display: none;
  }
`

const ImageMobile = styled(Image)`
  height: 100%;
  object-fit: cover;

  @media ${screenSizes.tablet} {
    display: none;
  }
`
